<template>
  <!-- eslint-disable vue/require-toggle-inside-transition -->
  <transition
    name="generic-fade"
    mode="out-in"
    @before-enter="$emit('before-enter')"
  >
    <slot />
  </transition>
</template>

<style lang="postcss">
.generic-fade-enter-active,
.generic-fade-leave-active {
  transition: opacity .3s ease-in-out;
}

.generic-fade-enter,
.generic-fade-leave-to {
  opacity: 0;
}
</style>
